import React, { useEffect, useMemo, useState } from 'react'
import { DragDropContext } from 'react-beautiful-dnd'
import TableHeader from './TableHeader/TableHeader'
import RouteRow from './RouteRow/RouteRow'
import { UnassignedOrders } from './UnassignedOrders/UnassignedOrders'
import { mainApi } from '../../../../store/services/mainApi'

const LogisticTable = ({ unassignedOrders, assignedOrders }) => {
  const { data: routes, isLoading } = mainApi.useGetRoutesQuery()
  const [updateOrderLogistic] = mainApi.useUpdateOrderLogisticMutation()

  // Стейт для перетаскивания (как триггер)
  const [dndDrop, setDndDrop] = useState(false)

  // ⬇️ Новый стейт для заказов в маршрутах
  const [assignedOrdersState, setAssignedOrdersState] = useState(assignedOrders || [])

  useEffect(() => {
    if (assignedOrders && assignedOrders.length > 0) {
      setAssignedOrdersState(assignedOrders)
    }
  }, [assignedOrders])

  // Создание map маршрутов
  const routeMap = useMemo(() => {
    const map = {}
    if (routes) {
      routes.forEach((route) => {
        map[route._id] = route
      })
    }
    return map
  }, [routes])

  // Для отладки
  useEffect(() => {
    console.log(dndDrop, 'dndDrop')
  }, [dndDrop])

  const reorderOrders = (orders) => {
    return orders.map((order, index) => ({
      ...order,
      logistic: {
        ...order.logistic,
        position: index,
      },
    }))
  }

  const onDragEnd = async (result) => {
    const { draggableId, source, destination } = result

    // Если элемент был сброшен вне допустимой зоны
    if (!destination) return

    // Если элемент не был перемещён
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return
    }

    // Определение источника и назначения
    const sourceRouteId = source.droppableId
    const destRouteId = destination.droppableId

    // Поиск перемещаемого заказа
    const movedOrder = assignedOrdersState.find((order) => order._id === draggableId) || unassignedOrders.find((order) => order._id === draggableId)

    if (!movedOrder) return

    // Создание нового объекта logistic, если он отсутствует
    const newLogistic = {
      ...movedOrder.logistic,
      routeId: destRouteId,
      vanId: routeMap[destRouteId]?.vehicle || null,
      status: 'assigned',
      position: destination.index,
    }

    const updatedOrder = {
      ...movedOrder,
      logistic: newLogistic,
    }

    // Обновление состояния assignedOrdersState
    setAssignedOrdersState((prevOrders) => {
      // Удаление перемещаемого заказа из предыдущего состояния
      const filteredOrders = prevOrders.filter((order) => order._id !== draggableId)

      // Вставка обновлённого заказа в новое место
      const updatedOrders = [...filteredOrders]
      updatedOrders.splice(destination.index, 0, updatedOrder)

      // Пересчёт позиций заказов в маршруте
      const reorderedOrders = updatedOrders.map((order, index) => {
        if (order.logistic?.routeId === destRouteId) {
          return {
            ...order,
            logistic: {
              ...order.logistic,
              position: index,
            },
          }
        }
        return order
      })

      return reorderedOrders
    })

    // Обновление сервера
    try {
      await updateOrderLogistic({
        orderId: draggableId,
        logistic: newLogistic,
      })
    } catch (error) {
      console.error('Ошибка при обновлении данных:', error)
    }
  }

  const orderRows = useMemo(() => {
    if (unassignedOrders) {
      return unassignedOrders.map((order) => ({
        code: order?.tradeName,
        id: order?.particalId,
        _id: order?._id,
        comments: order?.driverComment,
        order,
        time: order?.deliveryTime || '',
        location: order?.address || order?.userAcc?.billAddress?.address,
        driver: order?.drivers,
        picker: order?.picker,
        picking: 0,
        delivery: 0,
        van: 'Cargado',
        status: order?.status?.name || 'New',
        payment: order?.paymentType,
        debt: 'soon',
        paid: order?.paidValue?.toFixed(2) || 0,
        total: 'soon',
        logistic: order?.logistic,
      }))
    }
    return []
  }, [unassignedOrders])

  // Преобразование assignedOrdersState в orderRows тоже
  const assignedRows = useMemo(() => {
    return assignedOrdersState.map((order) => ({
      code: order?.tradeName,
      id: order?.particalId,
      _id: order?._id,
      comments: order?.driverComment,
      order,
      time: order?.deliveryTime || '',
      location: order?.address || order?.userAcc?.billAddress?.address,
      driver: order?.drivers,
      picker: order?.picker,
      picking: 0,
      delivery: 0,
      van: 'Cargado',
      status: order?.status?.name || 'New',
      payment: order?.paymentType,
      debt: 'soon',
      paid: order?.paidValue?.toFixed(2) || 0,
      total: 'soon',
      logistic: order?.logistic,
    }))
  }, [assignedOrdersState])

  // const sortedRoutes = [...routes].sort((a, b) => {
  //   if (a.name === 'Wait List') return -1
  //   if (b.name === 'Wait List') return 1
  //   return 0
  // })

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <TableHeader />
      <UnassignedOrders orderRows={orderRows} />

      {isLoading ? (
        <div>Loading...</div>
      ) : (
        routes.map((route) => {
          const routeOrders = assignedRows.filter((order) => order.logistic?.routeId === route._id)
          return <RouteRow key={route._id} route={route} orderRows={routeOrders} dndDrop={dndDrop} />
        })
      )}
    </DragDropContext>
  )
}

export default LogisticTable
